interface PeriodDateProps {
  date: string;
}

const PeriodDate = ({ date }: PeriodDateProps) => {
  const [year, month] = date.split("-");
  return (
    <span className="flex flex-col items-center" data-testid="period-date">
      <span className="font-bold">{month}</span>
      <span className="text-xs text-gray-500">{year}</span>
    </span>
  );
};

export default PeriodDate;
